/**
 * Copyright (C) 2022 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import React from 'react';
import IconButton from '@mui/material/IconButton';
import Block from '@mui/icons-material/Block';
import MyLocation from '@mui/icons-material/MyLocation';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import {
  selectIsRequestingFlightPath,
  selectIsRequestingTailDetailsPanelTerminal,
  selectTailDetailsPanelTerminal,
} from '../../../store';
import { setFTVShouldZoomToFlightPath } from '../../../store/ui/actions';
import StyledProps from '../../common/theme/AppThemeInterface';

const BUTTON_HEIGHT = 32;
const FONT_SIZE = 18;
const PADDING = (BUTTON_HEIGHT - FONT_SIZE) / 2;

const PanToFlightBathButtonWrapper = styled.span`
  height: ${BUTTON_HEIGHT}px;
  background-color: ${({ theme }: StyledProps) => theme.secondaryBackgroundColor};
  border: none;
  border-radius: 5px;
  margin-left: 6px;

  .ftv__flightpath__zoom__button {
    color: ${({ theme }: StyledProps) => theme.primaryTextColor};
    height: ${BUTTON_HEIGHT}px;
    padding: ${PADDING}px;
  }

  .ftv__flightpath__zoom__button__icon {
    font-size: ${FONT_SIZE}px;
  }

  .ftv__flightpath__restricted__container {
    color: ${({ theme }: StyledProps) => theme.primaryTextColor};
    height: ${BUTTON_HEIGHT}px;
    padding: ${PADDING}px;
  }

  .ftv__flightpath__restricted__icon {
    font-size: ${FONT_SIZE}px;
  }
`;

const FullTailViewFlightPathZoomButton = () => {
  const dispatch = useDispatch();
  const isRequestingTailDetailsPanelTerminal = useSelector(selectIsRequestingTailDetailsPanelTerminal, shallowEqual);
  const tailDetailsPanelTerminal = useSelector(selectTailDetailsPanelTerminal, shallowEqual);
  const isRequestingFlightPath = useSelector(selectIsRequestingFlightPath, shallowEqual);

  const panToFlightPathOnMap = () => {
    dispatch(setFTVShouldZoomToFlightPath(true));
  };

  const restrictionEnabled = tailDetailsPanelTerminal && tailDetailsPanelTerminal.restrictionEnabled;
  return (
    <PanToFlightBathButtonWrapper>
      {restrictionEnabled ? (
        <div className="ftv__flightpath__restricted__container">
          <Block data-test="ftv_flightpath__zoom_restricted" className="ftv__flightpath__restricted__icon" />
        </div>
      ) : (
        <IconButton
          className="ftv__flightpath__zoom__button"
          onClick={panToFlightPathOnMap}
          disabled={isRequestingFlightPath || isRequestingTailDetailsPanelTerminal}
        >
          <MyLocation data-test="ftv_flightpath__zoom_button" className="ftv__flightpath__zoom__button__icon" />
        </IconButton>
      )}
    </PanToFlightBathButtonWrapper>
  );
};

export default FullTailViewFlightPathZoomButton;
